<template lang="html">
<div>
     <div class="inner-page">
<!--         <p class="orgName">{{organizations}}</p>-->
           <div class="header">
                <div class="head-inner">
                    <img :src="logoUrl">
                    <div class="head-text">中华民族音乐图书馆</div>
                    <SubItem class="subNavs" ref="subItem" :itemArrs="subArrs" labelType="right" @itemSelect="subSelect">
                        <div class="iconGp" @click="subOpen">
                              <van-icon class="icon" class-prefix="iconfont" name="more2" />
                        </div>
                    </SubItem>
                </div>
           </div>
           <Search />
           <div class="scroll-list" :style="'height:' + scrollH + 'px'">
                 <van-swipe class="banners" indicator-color="#af2d2d" :autoplay="3000">
                     <van-swipe-item class="slide" v-for="(item,index) in swpArrs" :key="index">
                         <img :src="'http://image.china1896.com/'+item.image" alt="">
                     </van-swipe-item>
                 </van-swipe>

                 <div class="authors">
                      <div class="a-ttl">艺术家</div>
                      <div class="a-content">
                           <div class="a-item" v-for="(item,index) in authors" :key="index" @click="authorSeek(item)">
                                 <div class="imgs">
                                      <img :src="item.image" alt="">
                                 </div>
                                 <div class="item-text">{{item.name}}</div>
                           </div>
                      </div>
                 </div>

                 <XPanel class="xPanel" v-for="(item,key) in recomendArr" :key="key" :classDat="recomendList[0][item]" :classKey="item" :songList="songList[key]"/>
                 <Footer />
           </div>
     </div>
</div>
</template>

<script>
import Search from "@/components/Search";
import XPanel from "./src/ixPanel";
import logoUrl from "@/assets/logo2.png";

import { getRecomend,getAuditionMaterialList,getBannerList,getCelebrityList } from "@/api/index";
import SubItem from "@/components/subItem";

import { mapState } from 'vuex';
import { mapActions } from 'vuex';
import storage from 'good-storage';
import {login } from "@/api/login";

export default {
    components:{
        XPanel,
        Search,
        SubItem,
    },
    computed:{
         ...mapState('user',{
              nickname:'nickname',
              realName:'realName',
              organization:'organization',
              headName(state){
                   return state.nickname || state.realName || state.organization || '中华传统音乐数字文献图书馆'
              }
         })
     },

    data(){
        return{
            logoUrl:logoUrl,
            swpArrs:[],
            authors:[],
            subArrs:['唱片中心','音乐检索','中国戏曲','中国曲艺','民族歌曲','民间器乐','歌舞音乐','我的音网'],
        //  推荐类型
            recomendList:[{}],
            recomendArr:['1090','1093','1091','1094','1092'],
            scrollH:'',
            songList:[],
            organizations:''
        }
    },
    methods:{
        ...mapActions('user',[
            'AuserSet'
        ]),

        storeDispatch:function(e){
            this.AuserSet(e);
        },

        getRecomend:function(){
             let vues = this;
             getRecomend({parentIds:['1090','1093','1091','1094','1092']}).then(res => {
                  let resDat = res.subjectList;
                  let tempList = {};
                  for(let i = 0;i < resDat.length;i++){
                      if(!tempList[resDat[i].parentId]){
                           tempList[resDat[i].parentId] = [];
                      }
                      tempList[resDat[i].parentId].push(resDat[i]);
                  }

                  vues.recomendList.splice(0,1,tempList);
             }).catch(error => {
                 window.console.log(error);
             })
        },
        //获取banner列表
        getBannerListFun(){
            let vue = this;
            getBannerList().then(res => {
                vue.swpArrs = res.bannerList;
            }).catch(error => {
                window.console.log(error);
            })
        },
        // 获取艺术家列表
        getCelebrityListFun(){
            let vue = this;
            getCelebrityList().then(res => {
                vue.authors = res.celebrityList;
            }).catch(error => {
                window.console.log(error);
            })
        },
        subSelect:function(e){
            if(e.inx == 0){
                 this.push('index');
            }else if(e.inx == 1){
                 this.push('seek');
            }else if(e.inx >= 2 && e.inx < 7){
                 let urlArrs = [
                     { classId:1090,classText:'全部中国戏曲' },
                     { classId:1093,classText:'全部中国曲艺' },
                     { classId:1091,classText:'全部民族歌曲' },
                     { classId:1094,classText:'全部民间器乐' },
                     { classId:1092,classText:'全部歌舞音乐' }
                 ];

                 let nowClass = urlArrs[e.inx - 2];
                 let query = {
                    classId:nowClass.classId,
                    classText:nowClass.classText,
                    postKey:'classifyList',
                    classType:1
                 };
                 this.push({
                      path:'seek',
                      query
                 });

                 if(this.$route.name == 'seek'){
                     this.$emit('goFrash');
                 }
            }else if(e.inx == 7){
                 this.push('me');
            }
        },
        subOpen:function(){
            this.$refs.subItem.show();
        },
        authorSeek:function(item){
            this.push({
                 path:'seek',
                 query:{
                    stext:item.name
                 }
            });
        },
        swpLink:function(x){
            if(x === 3){
                this.push('project');
            }
        },
        getUrls:function (name){
            var reg = new RegExp('(^|&)' + name + '=([^&]*)(&|$)', 'i');
            var r = window.location.search.substr(1).match(reg);
            if(r != null) {
                return unescape(r[2]);
            }
            return null;
        },
        toLogin:function () {
            let vues = this;
            login({
                account:vues.getUrls('account'),
                pwd:vues.getUrls('pwd')
            }).then(res => {
                storage.set('userInfo',{
                    token:res.token,
                    userId:res.id,
                    imageUrl:res.imageUrl,
                    nickname:res.nickname,
                    organization:res.organization,
                    memberEnd:res.memberEnd,
                });
                // storage.set('organizationName',res.organization)
                vues.storeDispatch(res);
                this.organizations = res.organization
            }).catch(errs => {
                // vEmits.$emit('show',errs);
                window.console.log(errs)
            })
        }
    },
    mounted(){
        window.console.log(window.location.href)
        if(window.location.href=='http://wap.china1904.com/wx/index?account=zhejiangshengtsg&pwd=china1896'){
            window.location.href='http://m.china1901.com/#/?identity=2c9f23fc74954f1601749b671ca30d30'
        }
        if(this.getUrls('account')==null){
            storage.remove('userInfo')
            storage.remove('pwd')
            storage.remove('userName')
        }
        // 获取首页数据
        getAuditionMaterialList({classifyIdList:['1090','1093','1091','1094','1092']}).then(res => {
            this.songList = res.materialAuditionList;
        }).catch(error => {
            window.console.log(error)
        });
        this.getBannerListFun();
        this.getCelebrityListFun();
        if(storage.get("noLogin")&&storage.get("userInfo")!==null){
            this.toLogin();
        }else{
            this.storeDispatch(storage.get("userInfo"));
        }

    },

    // // 业务代码
    beforeCreate () {
        if(storage.get("userInfo")){
            document.title = storage.get("userInfo").organization
        }else{
            document.title = '中国音网'
        }
    },
    created:function(){

        this.getRecomend();
        this.scrollH = document.documentElement.clientHeight - 170;

    },

}
</script>

<style lang="css" scoped>
.orgName{
    color: rgb(174, 30, 36);
    font-size: 12px;
    padding-left: 10px;
}
.scroll-list{
    position: relative;
    overflow-y: scroll;
    overflow-x: hidden;
}

.inner-page{
    padding-bottom: 60px;
    overflow-x: hidden;
}

/* 头部 */

.header{
    height: 50px;
    position: relative;
    z-index: 2;
    background: black;
}

.head-inner{
    height: 50px;
    position: relative;
    margin: 0 12px;
    display: flex;
    align-items: center;
    justify-content: space-between;
}

.header img{
    height: 35px;
}

.head-text{
    color: white;
    margin-left: 9px;
    flex-grow: 1;
}

.iconGp{
    height: 50px;
    line-height: 50px;
}

.head-inner .icon{
    color: white;
    font-size: 24px;
}

/* 检索 */

.inner-body{
    font-size: 14px;
}

/* swiper */

.banners{
    background: #f5f5f5;
}

.slide img{
   width: 100%;
}

/* 艺术家 */

.authors{
    background: white;
    padding: 15px 0;
}

.a-ttl{
    font-size: 16px;
    font-weight: bold;
    text-align: left;
    margin: 0 10px;
}

.a-content{
    display: flex;
    margin: 0 15px;
    text-align: center;
    justify-content: space-between;
    flex-direction: row;
    flex-wrap: wrap;
}

.a-item .imgs{
    width: 70px;
    height: 70px;
    border-radius: 70px;
    background: #f5f5f5;
    margin-top: 12px;
    margin-bottom: 9px;
}

.a-item .imgs img{
    width: 70px;
    height: 70px;
}

.a-item .item-text{
    font-size: 13px;
    color: #666666;
    max-width: 70px;
}

/* 分类块 */

.xPanel{
   background: white;
   margin-top: 6px;
}

</style>
